export default __webpack_public_path__ + "static/media/DSC_0759.88ce18a9.JPG";